export default __webpack_public_path__ + "static/media/3x3_pink.8594c1fd.png";